export type PurchaseNotification = {
  id: string
  firstName: string
  location: string
}

/**
 * Placeholder feed for the purchase notification component.
 *
 * These entries are NOT real transactions — they exist so the component can be
 * previewed. In production, replace `defaultPurchaseFeed` with data loaded from
 * real order records or an approved external data source, keeping the same
 * `PurchaseNotification` shape.
 */
export const defaultPurchaseFeed: PurchaseNotification[] = [
  { id: 'sample-1', firstName: 'Emily', location: 'Austin, TX' },
  { id: 'sample-2', firstName: 'Daniel', location: 'Toronto, ON' },
  { id: 'sample-3', firstName: 'Sophie', location: 'Manchester, UK' },
  { id: 'sample-4', firstName: 'Olivia', location: 'Brisbane, QLD' },
  { id: 'sample-5', firstName: 'Liam', location: 'Auckland, NZ' },
  { id: 'sample-6', firstName: 'Aoife', location: 'Dublin, Ireland' },
  { id: 'sample-7', firstName: 'Grace', location: 'Denver, CO' },
  { id: 'sample-8', firstName: 'Nathan', location: 'Vancouver, BC' },
  { id: 'sample-9', firstName: 'Chloe', location: 'Edinburgh, UK' },
  { id: 'sample-10', firstName: 'Marcus', location: 'Perth, WA' },
  { id: 'sample-11', firstName: 'Hannah', location: 'Raleigh, NC' },
  { id: 'sample-12', firstName: 'Priya', location: 'Calgary, AB' },
]
